// extracted by mini-css-extract-plugin
export var container = "_eb-0";
export var icon = "_eb-1";
export var text = "_eb-2";